// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__fZ0fC","header":"View_header__srd3f","footer":"View_footer__M5WgX","tabs":"View_tabs__VG2HT","spin":"View_spin__fYXL6"};